/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2023-08-22 11:43:42
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2025-07-14 17:11:02
 */
import axios, { type AxiosResponse } from 'axios'
import { useMessage } from 'naive-ui'
import { useAuthStore } from '@/store'
import { ss } from '@/utils/storage'

const message = useMessage()
const service = axios.create({
  baseURL: import.meta.env.VITE_GLOB_API_URL,
})

const tokenData = ref('')

service.interceptors.request.use(
  (config) => {
    const token = ss.get('SECRET_TOKEN')
    tokenData.value = ss.get('SECRET_TOKEN')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`

      // config.headers.token = token
      config.headers.cowork = ss.get('SECRET_TOKEN')
      // config.headers.token = '2oA0DfIGkK4JqarpHkotpG7jd5CQZk4k2KDZEktjT2LvdLy7bG24uXOvASXhMzhV'
      // config.headers['x-token'] = 'WcFvY5sydv8I_PhjYQMYWg'
    }

    return config
  },
  (error) => {
    return Promise.reject(error.response)
  },
)

service.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    if (response.status === 200) {
      if (response.data.code === 40003) {
        const token = ss.get('SECRET_TOKEN')
        if (token === tokenData.value) {
          useAuthStore().removeToken()
          if (window.location.pathname !== '/login') {
            const redirectUrl = window.location.pathname + window.location.search
            window.location.href = `/login?redirect=${encodeURIComponent(redirectUrl)}`
          } else {
            window.location.href = '/login'
          }
        }
      }
      return response
    }
    throw new Error(response.status.toString())
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default service
